import { jsx as _jsx } from "react/jsx-runtime";
import useToggleButtonGroup from "./ProfileMenuToggle.hook.js";
import { Root } from "./ProfileMenuToggle.components.js";
export const ProfileMenuToggleMoleculeComponent = ({ selectedSubItemId, subItems, }) => {
    const { value, toggleButtonChangeHandler } = useToggleButtonGroup({ selectedSubItemId, subItems });
    if (subItems?.length) {
        return _jsx(Root, { exclusive: true, data: subItems, value: value, onChange: toggleButtonChangeHandler, orientation: "vertical" });
    }
    else {
        return null;
    }
};
export default ProfileMenuToggleMoleculeComponent;
